import { render, staticRenderFns } from "./setbid.vue?vue&type=template&id=42c8d472&scoped=true&"
import script from "./setbid.vue?vue&type=script&lang=js&"
export * from "./setbid.vue?vue&type=script&lang=js&"
import style0 from "./setbid.vue?vue&type=style&index=0&id=42c8d472&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c8d472",
  null
  
)

export default component.exports